module.exports = __webpack_public_path__ + "img/melia-resort-3.d2e33ec3.jpg";